/**
 * Low-stock status by TOTAL stock (Pusat + Cabang).
 * Effective threshold = item.minStock if set, else the global default.
 * total < 0 is "negative" (owed/borrowed — distinct from a plain "out", stock notification
 * task); total === 0 is "out". Both are still legal, never-blocked states — see the negative
 * stock invariant elsewhere in this app.
 */
export function itemTotal(item) {
  return (Number(item.stokPusat) || 0) + (Number(item.stokCabang) || 0);
}

export function stockStatus(item, globalThreshold = 0) {
  const total = itemTotal(item);
  if (total < 0) return "negative"; // owed/borrowed — distinct from a plain zero
  if (total === 0) return "out";
  const eff = item.minStock != null ? (Number(item.minStock) || 0) : (Number(globalThreshold) || 0);
  if (eff > 0 && total <= eff) return "low";
  return "ok";
}
